const translation = {
  transactionDetails: 'Transaction Details',
  billReport: 'Bill Overview',
  scheduledSend: 'Scheduled Send',
  planList: 'Plan List',
  createPlan: 'Create Plan',
  editPlan: 'Edit Plan',
  costBill: 'Cost Bill',
  resourceTop10: 'Resource Consumption Top 10',
  cycleBill: 'Bill Detail',
  monthlyBill: 'Monthly Bill',
  annualBill: 'Annual Bill',
  groupedBill: 'Grouped Bill',
  recharge: 'Recharge',
  rechargeDetail: 'Recharge Detail',
  rechargeAlert1:
    'Recharge amount can only be used for platform consumption. Invoice can be issued after consumption.',
  rechargeAlert2:
    'Recharge amount does not support refund, please proceed with caution.',
  accountBalance: 'Account Balance',
  rechargeTip:
    'Recharge amount can only be used for platform consumption. Invoice can be issued after consumption.',
  orderList: 'Order List',
  usageManagement: 'Usage Management',
  usageOverview: 'Usage Overview',
  usageAnalysis: 'Usage Analysis',
  serialNumber: 'Serial Number',
  account: 'Account',
  availableBalance: 'Available Balance',
  ioType: 'IO Type',
  tradeType: 'Trade Type',
  channel: 'Channel',
  amount: 'Amount',
  changeAmount: 'Change Amount',
  balance: 'Balance',
  comment: 'Comment',
  commentMaxLength: 'Notes can be up to 500 characters',
  channelSerialNumber: 'Channel Serial Number',
  tradeTime: 'Trade Time',
  action: 'Action',
  detail: 'Detail',
  productName: 'Product Name',
  productNameRule: 'Product name must consist of letters and numbers',
  productSpec: 'Product Spec',
  productSpecRule:
    'Product spec must consist of letters, numbers, ".", "/", and "-"',
  postPaid: 'Postpaid',
  monthlyPaid: 'Monthly Paid',
  annualPaid: 'Annual Paid',
  confirm: 'Confirm',
  cancel: 'Cancel',
  onlineRecharge: 'Online Recharge',
  rechargeAmount: 'Recharge Amount',
  inputRechargeAmount: 'Please enter recharge amount',
  rechargeAmountGreaterThanZero: 'Recharge amount must be greater than 0',
  iHaveRead: 'I have read:',
  createRechargeOrder: 'Create Recharge Order',
  orderId: 'Order ID',
  type: 'Order Type',
  product: 'Product',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  paidAt: 'Paid At',
  deletePlan: 'Delete Plan',
  edit: 'Edit',
  delete: 'Delete',
  postPaidPrice: 'Postpaid Price',
  postPaidBillCycle: 'Postpaid Billing Cycle',
  monthlyPrice: 'Monthly Price',
  annualPrice: 'Annual Price',
  paginationTotal: 'Items {start}-{end} of {total}',
  orderSummary: 'Order Summary',
  orderType: 'Order Type',
  orderDetailType: 'Type',
  payType: 'Pay Type',
  prepaid: 'Prepaid',
  postpaid: 'Postpaid',
  name: 'Name',
  architecture: 'Architecture',
  preferRegion: 'Prefer Region',
  preferZone: 'Prefer Zone',
  createOrder: 'Create Order',
  userId: 'User ID',
  buyAccount: 'Buy Account',
  payChannel: 'Pay Channel',
  inputSerialNumber: 'Please enter serial number',
  filterOrderId: 'Order ID',
  inputOrderId: 'Please enter order ID',
  inputChannelSerialNumber: 'Please enter channel serial number',
  startTime: 'Start Time',
  endTime: 'End Time',
  selectTradeType: 'Please select trade type',
  search: 'Search',
  reset: 'Reset',
  channelAlipay: 'Alipay',
  channelBalance: 'Balance',
  unknown: 'unknown',
  status: 'Status',
  assetId: 'Asset ID',
  usage: 'Usage',
  price: 'Price',
  statusMap: {
    running: 'Running',
    paused: 'Paused',
    deleted: 'Deleted',
    stopped: 'Stopped',
    unknown: 'Unknown',
  },
  statusPending: 'Pending',
  statusCompleted: 'Completed',
  statusCancelled: 'Cancelled',
  ioIn: 'Income',
  ioOut: 'Expense',
  tradeRecharge: 'Recharge',
  tradeConsume: 'Consume',
  tradePostpaid: 'Postpaid',
  tradePrepaid: 'Prepaid',
  resourceId: 'Resource ID',
  resourceType: 'Resource Type',
  resourceName: 'Resource Name',
  orderDetail: 'Order Detail',
  canceledAt: 'Canceled At',
  projectId: 'Project ID',
  payOrder: 'Pay Order',
  backToList: 'Back to {{type}} List',
  vm: 'VM',
  baremetal: 'Bare Metal',
  disk: 'Disk',
  productTypes: {
    gpu: 'AI Computing',
    vdisk: 'AI Storage',
    disk: 'Block Storage',
    ecs: 'Virtual Machine',
    baremetal: 'Bare Metal',
    harbor: 'Image Repository',
  },
  regions: {
    'cn-east-1': 'East China 1',
    'cn-east-2': 'East China 2',
    'cn-south-1': 'South China 1',
    'cn-north-1': 'North China 1',
    'cn-southwest-1': 'Southwest China 1',
  },
  invoiceStatus: {
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
  },
  invoice_status: {
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  trade_type: {
    recharge: 'Recharge',
    consume: 'Prepaid',
    postpaid: 'Postpaid',
    refund: 'Refund',
  },
  order_type: {
    recharge: 'Recharge',
    purchase: 'Purchase',
    renew: 'Renewal',
    unsubscribe: 'Unsubscribe',
  },
  io_type: {
    in: 'Income',
    out: 'Expense',
  },
  orderTagType: {
    RECHARGE: 'Recharge',
    PURCHASE: 'Purchase',
    RENEW: 'Renew',
    UNSUBSCRIBE: 'Unsubscribe',
  },
  date: 'Date',
  project: 'Project',
  billingType: 'Billing Mode',
  region: 'Region',
  totalAmount: 'Total Amount',
  month: 'Month',
  report_user_config_modal: {
    title: 'Scheduled Sending',
    enable_report: 'Enable Scheduled Report',
    time_unit: 'Send Frequency',
    time_unit_required: 'Please select send frequency',
    time_unit_monthly: 'Monthly',
    time_unit_weekly: 'Weekly',
    time_unit_daily: 'Daily',
    email: 'Recipient Email',
    email_required: 'Please enter recipient email',
    email_placeholder: 'Please enter recipient email',
    confirm: 'Confirm',
  },
  admin_bill_list: {
    title: 'Order Management',
    order_id: 'Order ID',
    user: 'User',
    order_type: 'Order Type',
    amount: 'Amount',
    balance: 'Actual Amount',
    discount: '({discount} off)',
    status: 'Status',
    created_at: 'Created At',
    updated_at: 'Updated At',
    operations: 'Operations',
    modify_price: 'Modify Price',
    cancel_order: 'Cancel Order',
    cancel_order_confirm: 'Are you sure to cancel the order?',
    original_price: 'Original Price',
    discount_price: 'Discount Price',
    discount_price_required: 'Please enter discount price',
    discount_price_placeholder: 'Please enter discount price',
    confirm: 'Confirm',
    unknown: 'Unknown',
  },
  admin_coupon_list: {
    title: 'Coupon Management',
    placeholder: 'Search Coupon ID/Name',
    create: 'Add Coupon',
    alert1:
      'Coupons can be used to pay for prepaid orders or postpaid bill fees, but cannot be used to offset arrears. When applying for refunds, coupons are not refundable; coupons do not support extension, invoicing, withdrawal, or cross-account use.',
    alert2:
      'Coupons can only be used within their validity period. If the prepaid order placement or postpaid billing deduction time is before the coupon effective time or after the coupon expiration time, the coupon cannot be used; the validity period of coupons cannot be extended.',
    alert3:
      'When active coupons are voided, the already effective portion is not affected.',
    id: 'ID',
    nameAndId: 'Name / ID',
    total_amount: 'Total Amount',
    applicable_products: 'Applicable Products',
    payment_method: 'Payment Method',
    applicable_orders: 'Applicable Orders',
    usage_limit: 'Usage Limit',
    validity_period: 'Validity Period',
    status: 'Status',
    created_by: 'Created By',
    issuer: 'Issuer',
    created_at: 'Created At',
    issue_time: 'Issue Time',
    valid_from: 'Valid Time',
    valid_to: 'Valid To',
    updated_at: 'Updated At',
    operations: 'Operations',
    detail: 'Detail',
    send: 'Send Manually',
    invalidate: 'Invalidate',
    copy: 'Copy',
    invalidate_confirm_title: 'Confirm Invalidation',
    invalidate_confirm_desc:
      'Please confirm whether to invalidate this coupon. After execution, all coupons for related users will be invalidated and cannot be recovered. The coupons that have been executed will not be affected. Please proceed with caution.',
    invalidate_success: 'Coupon invalidated successfully',
    invalidate_failed: 'Failed to invalidate coupon',
    confirm: 'Confirm',
    cancel: 'Cancel',
    unknown: 'Unknown',
    empty_text: 'No Data',
    sendCoupon: {
      title: 'Send Coupon',
      success: 'Coupon sent successfully',
      failed: 'Failed to send coupon',
      selectUsers: 'Select Users',
      selectUsersPlaceholder: 'Please search and select users to send coupon',
      selectUsersRequired: 'Please select users to send',
      couponName: 'Coupon Name',
      couponId: 'Coupon ID',
    },
    couponStatus: {
      pending: 'Pending',
      active: 'Active',
      expired: 'Expired',
      voided: 'Voided',
      used: 'Used',
      stopped: 'Stopped',
    },
    all_products: 'All Products',
    part_products: 'Partial Products',
  },
  coupon: {
    create: {
      title: 'Create Coupon',
      action: 'Create Coupon',
    },
    detail: {
      title: 'Coupon Detail',
      basicInfo: 'Basic Information',
      loading: 'Loading...',
      notFound: 'Coupon not found',
      user_usage_history: 'User Usage History',
      tabs: {
        basicInfo: 'Basic Information',
        usageHistory: 'Usage History',
      },
    },
    usage: {
      title: 'Usage History',
      description: 'Display all usage records for this coupon',
      userName: 'UserName',
      orderNo: 'Order No',
      changeAmount: 'Order Amount',
      discountAmount: 'Change Amount',
      status: 'Status',
      statusUsed: 'Used',
      statusRefunded: 'Refunded',
      usedAt: 'Time',
      userID: 'User ID',
      user_name: 'User Name',
    },
    form: {
      basicInfo: {
        title: 'Basic Information',
        name: 'Coupon Name',
        namePlaceholder: 'Please enter coupon name',
        namePattern:
          'Supports Chinese, English, numbers, hyphens and underscores, length 3-64',
        amount: 'Coupon Amount',
        amountPlaceholder: 'Please enter coupon amount',
        amountRequired: 'Please enter coupon amount',
        amountMin: 'Amount must be greater than 0',
        amountMax: 'Only two decimal places are supported',
        validityPeriod: 'Validity Period',
        status: 'Coupon Status',
        validityPeriodRequired: 'Please select validity period',
        startDate: 'Start Date',
        endDate: 'End Date',
      },
      applicableScope: {
        title: 'Applicable Scope',
        products: 'Applicable Products',
        productsPlaceholder: 'Please select applicable products',
        paymentMethod: 'Payment Method',
        paymentMethodPlaceholder: 'Please select payment method',
        allPaymentMethods: 'All Payment Methods',
        prepaid: 'Prepaid',
        postpaid: 'Postpaid',
        orders: 'Applicable Orders',
        ordersPlaceholder: 'Please select applicable orders',
        allOrders: 'All Orders',
        newOrders: 'New Orders',
        existingOrders: 'Existing Orders',
      },
      otherInfo: {
        title: 'Other Information',
        usageLimit: 'Usage Limit',
        usageLimitDesc: 'Available after ¥0.00',
        usageLimitPlaceholder: 'Please select usage limit',
        unlimited: 'Unlimited',
        once: 'Use Once Only',
        multiple: 'Multiple Use',
        notes: 'Notes',
        notesPlaceholder: 'Please enter coupon note',
      },
      submit: 'Confirm',
      cancel: 'Cancel',
    },
    issuedUsers: 'Issued Users',
    usageHistory: 'Usage History',
  },
  promotion: {
    list: {
      title: 'Promotion Management',
      add: 'Add Promotion',
      search_placeholder: 'Search Promotion ID/Name',
      search: 'Search',
      table: {
        id: 'ID',
        nameAndId: 'Name / ID',
        promotionType: 'Promotion Type',
        promotionContent: 'Promotion Info',
        allProduct: 'Applicable Products',
        allProduct_all: 'All Products',
        allProduct_part: 'Partial Products',
        purchaseMethods: 'Payment Methods',
        orderTypes: 'Applicable Orders',
        endTime: 'Validity Period (UTC+8)',
        status: 'Status',
        createdBy: 'Creator',
        initiator: 'Activity Initiator',
        createdAt: 'Created At',
        action: 'Action',
        detail: 'Detail',
        stop: 'Stop',
        copy: 'Copy',
      },
      status: {
        pending: 'Pending',
        active: 'Active',
        expired: 'Expired',
        stopped: 'Stopped',
        unknown: 'Unknown',
      },
      stop_modal: {
        title: 'Stop Promotion',
        content:
          'Please confirm whether to stop. This operation cannot be undone. Orders already placed will not be affected. Please proceed with caution.',
        ok: 'OK',
        cancel: 'Cancel',
      },
      table_total: 'Total {{total}} records',
      alert1:
        'Multiple promotion mechanism: A single product can participate in multiple promotions at the same time. The system will automatically calculate the price under all valid promotion rules and use the lowest price as the final display and sales price.',
      alert2:
        'Once a promotion is stopped, the system will automatically recalculate the other promotions the product is participating in and dynamically adjust the price according to the new effective rules. If there are no other active promotions, the original price will be restored.',
      alert3:
        'It is recommended to regularly check the validity and effectiveness of promotions to avoid profit erosion caused by multiple discounts.',
      alert4:
        'After the promotion ends, it is recommended to check whether the product price has been correctly restored to ensure that no missed promotions affect normal sales.',
    },
    create: {
      title: 'Add Promotion',
      form: {
        name: {
          label: 'Activity Name',
          placeholder: 'Please enter activity name',
          extra:
            'Supports Chinese, English, numbers, hyphens, underscores, length 3-64',
          required: 'Please enter activity name',
          length: 'Activity name length should be 3-64 characters',
          pattern:
            'Activity name can only contain Chinese, English, numbers, hyphens and underscores',
        },
        type: {
          label: 'Promotion Type',
          discount: 'Limited Time Discount',
        },
        discount: {
          label: 'Discount/%',
          placeholder: 'Please enter discount',
          extra: 'Please enter an integer between 1 and 99, 0 means free',
          required: 'Please enter discount',
          range: 'Discount must be greater than 1 and less than 99',
        },
        validFrom: {
          label: 'Validity Period',
        },
        comment: {
          label: 'Comment',
          placeholder:
            'Please enter comment for management, not shown to users',
          extra: 'Please enter comment for management, not shown to users',
        },
        submit: 'OK',
        cancel: 'Cancel',
      },
      productModal: {
        title: 'Select Products',
        search_placeholder: 'Please enter product name to search',
        search: 'Search',
        ok: 'OK',
        cancel: 'Cancel',
        selected: 'Selected Products:',
      },
    },
    detail: {
      title: 'Promotion Detail',
      notFound: 'Promotion does not exist',
      loading: 'Loading...',
      baseInfo: 'Basic Info',
      id: 'Activity ID',
      promotionType: 'Promotion Type',
      validPeriod: 'Validity Period',
      promotionContent: 'Promotion Info',
      createdBy: 'Creator',
      createdAt: 'Created At',
      comment: 'Comment',
      allProduct: 'Applicable Products',
      allProduct_all: 'All Products',
      allProduct_part: 'Partial Products',
      free: 'Free',
      discountUnit: 'Discount',
    },
    applicableProducts: {
      title: 'Applicable Products',
      table: {
        id: 'Product ID',
        name: 'Product Name',
        type: 'Product Type',
        regions: 'Regions',
        clusters: 'Clusters',
        paymentMethods: 'Payment Methods',
        orderTypes: 'Applicable Orders',
      },
      total: 'Total {{total}}',
    },
    applicableScope: {
      productName: 'Product Name',
      productTypes: 'Product Type',
      productTypes_placeholder: 'Please select product type',
      productTypes_required: 'Please select product type',
      regions: 'Regions',
      regions_tips: 'Model services only apply to default regions',
      regions_placeholder: 'Please select region',
      regions_required: 'Please select region',
      clusters: 'Clusters',
      clusters_tips: 'Model services only apply to default clusters',
      clusters_placeholder: 'Please select cluster',
      clusters_required: 'Please select cluster',
      allProduct: 'Applicable Products',
      allProduct_all: 'All Products',
      allProduct_part: 'Partial Products',
      allProduct_required: 'Please select applicable products',
      planIds: 'Select Available Products',
      planIds_placeholder: 'Please select specific products',
      planIds_required: 'Please select specific products',
      modelIds: 'Select Models',
      modelIds_placeholder: 'Please select models',
      modelIds_required: 'Please select models',
      purchaseMethods: 'Payment Methods',
      purchaseMethods_required: 'Please select payment methods',
      purchaseMethods_month: 'Prepaid-Monthly',
      purchaseMethods_year: 'Prepaid-Yearly',
      purchaseMethods_post: 'Postpaid',
      purchaseMethods_postTooltip: 'Model services only support postpaid method. If model services are selected, postpaid must be checked for the promotion to take effect.',
      orderTypes: 'Applicable Orders',
      orderTypes_required: 'Please select applicable orders',
      orderTypes_new: 'New Order',
      orderTypes_auto: 'Auto Renewal',
      orderTypes_manual: 'Manual Renewal',
      modelServiceConflictTip: 'Model service cannot participate in promotion activities together with other products',
    },
  },
  'new-product': {
    title: 'Product Management',
    addProduct: 'Add Product',
    searchPlaceholder: 'Please enter product name or ID to search',
    resourceTagsLimit: 'Resource tags can only be selected 3 at most',
    table: {
      id: 'ID',
      nameAndId: 'Name / ID',
      productType: 'Product Type',
      productName: 'Product Name',
      availableRegion: 'Available Region',
      clusterResource: 'Cluster Resource',
      postPaidPrice: 'Postpaid Price',
      postPaidPriceTooltip: 'Model service postpaid price includes: inference input price and inference output price',
      monthlyPrice: 'Monthly Price',
      annualPrice: 'Annual Price',
      sortOrder: 'Sort Order',
      sortOrderTooltip: 'Sort order determines the display sequence of products in the compute market: larger values rank higher. If the sort order is the same, products are sorted by price from low to high. Default value is 1, only positive integers can be entered.',
      status: 'Purchase Status',
      statusTooltip: '"Online" status means that 【AI Compute】 products are open to users, who can view and purchase them when creating container instances, training tasks, or inference services in the machine learning platform. For 【Model Service】 products, it means they can be viewed and purchased in the model marketplace.',
      publishStatus: 'Publish Status',
      publishStatusTooltip: 'Only products with "Online" status can be published to the compute market. After publishing, the product will be visible to all users and support purchase and use.',
      published: 'Published',
      unpublished: 'Unpublished',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      action: 'Action',
      detail: 'Detail',
      edit: 'Edit',
      online: 'Online',
      offline: 'Offline',
      publish: 'Publish',
      cancelPublish: 'Cancel Publish',
      singlePromotion: 'Single Promotion',
      delete: 'Delete',
      onlineStatus: 'Online',
      offlineStatus: 'Offline',
      pricePerHour: '¥{{price}}/hour',
      pricePerMonth: '¥{{price}}/month',
      pricePerYear: '¥{{price}}/year',
      noPrice: '-',
      disabledEditWarning: 'Please take the product offline before editing',
      disabledPublishWarning:
        'Please take the product online before publishing',
      disabledDeleteWarning: 'Please take the product offline before deleting',
      disabledOnlineWarning: 'Please replenish the product inventory before taking it online',
      cannotPublishWaring:
        'The product type does not support publication to the computing power marketplace.',
    },
    modal: {
      delete: {
        title: 'Delete Product',
        content:
          'Please confirm whether to delete this product. After deletion, it cannot be recovered. Please proceed with caution.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      offline: {
        title: 'Offline Product',
        content:
          'Please confirm whether to take this product offline. After the product is taken offline from the machine learning platform, it will not be available for purchase and use within the platform. If the product has been published to the computing power market, it will also be synchronized offline from the computing power market and will no longer be displayed or provided to users.',
        contentModel:
          'After "Offline"【Model Service】, the model will become free in the model square, and users can use it for free. If you want to take the model service offline, please go to the machine learning platform model management to take it offline.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      online: {
        title: 'Online Product',
        content:
          'Please confirm whether to put this product online. "Online" refers to publishing the product to the machine learning platform. After the product is online, users can view and select the product in the machine learning platform to purchase and use when creating container instances, training tasks, or inference services.',
        contentModel:
          '“Online”【Model Service】 is the model support for the model square in the machine learning platform to sell at the set price.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      publish: {
        title: 'Publish Product',
        content:
          'Please confirm whether to publish this product. Only products with "Online" status can be published to the computing power market. After publication, this product will be visible to all users in the computing power market and support purchase and use.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      cancelPublish: {
        title: 'Cancel Product Publication',
        content:
          'Please confirm whether to cancel the publication of this product. After canceling publication, this product will be taken offline from the computing power market.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    message: {
      fetchFailed: 'Failed to get product list, please try again',
      deleteSuccess: 'Product deleted successfully!',
      deleteFailed: 'Delete failed, please try again',
      onlineSuccess: 'Product online successfully!',
      offlineSuccess: 'Product offline successfully!',
      publishSuccess: 'Product published successfully!',
      cancelPublishSuccess: 'Product publication canceled successfully!',
      operationFailed: 'Operation failed, please try again',
      soldOutWarning:
        'Products with sold-out inventory cannot be put online, please replenish inventory first',
      publishFailed: 'Publication failed, please try again',
      cancelPublishFailed: 'Cancel publication failed, please try again',
    },
    pagination: {
      total: 'Items {start}-{end} of {total}',
    },
    detail: {
      title: 'Product Management',
      loading: 'Loading...',
      productNotFound: 'Product not found',
      productIdRequired: 'Product ID cannot be empty',
      loadProductFailed: 'Failed to load product information',
      basicInfo: 'Basic Information',
      operationHistory: 'Product Operation History',
      promotionHistory: 'Promotion History',
      onlineStatus: 'Online',
      offlineStatus: 'Offline',
      publishedStatus: 'Published',
      unpublishedStatus: 'Unpublished',
      detailSuffix: 'Detail',
      // BasicInfoTab component translations
      basicInfoTab: {
        back: 'Back',
        edit: 'Edit',
        adjustPrice: 'Adjust Price',
        singlePromotion: 'Single Promotion',
        basicInfo: 'Basic Information',
        productSpecId: 'ID',
        productName: 'Product Name',
        productType: 'Product Type',
        status: 'Online Settings',
        region: 'Available Region',
        clusterId: 'Resource Cluster',
        productSpec: 'Product Spec',
        inventoryStatus: 'Inventory Status',
        labels: 'Resource Labels',
        priceInfo: 'Price Information',
        hourlyBilling: 'Hourly Billing',
        monthlyBilling: 'Monthly Billing',
        annualBilling: 'Annual Billing',
        notSupported: 'Not Supported',
        billingCycleConfig: 'Billing Cycle Configuration',
        supportHourlyBilling: 'Support Hourly Billing',
        supportMonthlyBilling: 'Support Monthly Billing',
        supportAnnualBilling: 'Support Annual Billing',
        postpaidBillingCycle: 'Postpaid Billing Cycle',
        hourly: 'Hourly',
        yes: 'Yes',
        no: 'No',
        online: 'Online',
        offline: 'Offline',
        inventoryType: {
          enough: 'Sufficient',
          surging: 'Tight',
          soldOut: 'Sold Out',
        },
        priceUnit: {
          perHour: '/hour',
          perMonth: '/month',
          perYear: '/year',
        },
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        createdBy: 'Created By',
      },
      // OperationHistoryTab component translations
      operationHistoryTab: {
        operator: 'Operator',
        postpaidPrice: 'Postpaid Price',
        monthlyPrice: 'Monthly Price',
        annualPrice: 'Annual Price',
        purchaseStatus: 'Purchase Status',
        publishStatus: 'Publish Status',
        inventoryStatus: 'Inventory Status',
        operationTime: 'Operation Time',
        online: 'Online',
        offline: 'Offline',
        published: 'Published',
        unpublished: 'Unpublished',
        noData: '-',
        inventoryEnough: 'Sufficient Resources',
        inventorySurging: 'Tight Resources',
        inventorySoldOut: 'Sold Out',
      },
      // PromotionHistoryTab component translations
      promotionHistoryTab: {
        activityId: 'Activity ID',
        activityName: 'Activity Name',
        promotionType: 'Promotion Type',
        activityDetails: 'Activity Details',
        originalPrice: 'Original Price',
        paymentMethod: 'Payment Method',
        applicableOrders: 'Applicable Orders',
        validPeriod: 'Valid Period',
        status: 'Status',
        initiator: 'Initiator',
        createTime: 'Create Time',
        statusMap: {
          pending: 'Pending',
          active: 'Active',
          inactive: 'Inactive',
        },
        promotionTypeMap: {
          discount: 'Discount',
          directReduction: 'Direct Reduction',
          freeTrial: 'Free Trial',
          memberPrice: 'Member Price',
        },
        free: 'Free',
      },
    },
    edit: {
      title: 'Product Management/Edit Product',
      loading: 'Loading...',
      productNotFound: 'Product not found',
      productIdRequired: 'Product ID cannot be empty',
      loadProductFailed: 'Failed to load product information',
      updateSuccess: 'Product updated successfully!',
      updateFailed: 'Update failed, please try again',
      form: {
        productType: 'Product Type',
        productTypeRequired: 'Please select product type',
        productTypePlaceholder: 'Please select product type',
        region: 'Available Region',
        regionRequired: 'Please select available region',
        regionPlaceholder: 'Please select available region',
        clusterResource: 'Cluster Resource',
        clusterResourceRequired: 'Please select cluster resource',
        clusterResourcePlaceholder: 'Please select cluster resource',
        productSpec: 'Product Name',
        productSpecRequired: 'Please select product name',
        productSpecPlaceholder: 'Please select product name',
        priceSettings: 'Original Price',
        postPaid: 'Postpaid',
        postPaidPrice: 'Please enter price',
        postPaidUnit: '/hour',
        monthlyPaid: 'Monthly Paid',
        monthlyPrice: 'Please enter price',
        monthlyUnit: '/month',
        modelUnit: '/million tokens',
        modelInPrice: 'Reasoning for input prices',
        modelOutPrice: 'Reasoning for output prices',
        modelInPriceRequired: 'Please enter reasoning for input prices',
        modelOutPriceRequired: 'Please enter reasoning for output prices',
        input: 'input',
        output: 'output',
        annualPaid: 'Annual Paid',
        annualPrice: 'Please enter price',
        annualUnit: '/year',
        onlineSettings: 'Online Settings',
        onlineSettingsDesc:
          '“Online” refers to publishing the product to the machine learning platform. After the product is online, users can view and select the product in the machine learning platform to purchase and use when creating container instances, training tasks, or inference services. ',
        online: 'Enable',
        offline: 'Disable',
        stockStatus: 'Stock Status',
        stockStatusEnough: 'Sufficient Resources',
        stockStatusSurging: 'Tight Resources',
        stockStatusSoldOut: 'Sold Out',
        resourceTags: 'Resource Tags',
        resourceTagsGeneral: 'General',
        resourceTagsCompute: 'Compute',
        resourceTagsMemory: 'Memory',
        resourceTagsHighPerformance: 'High Performance',
        resourceTagsSpecialOffer: 'Special Offer',
        customTag: 'Custom Tag',
        customTagPlaceholder: 'Please enter tag name',
        addCustomTag: '+ Custom Tag',
        addCustomTagSuccess: 'Tag added successfully!',
        addCustomTagFailed: 'Failed to add tag, please try again',
        customTagTitle: 'Add Custom Tag',
        sortOrder: 'Sort Order',
        sortOrderPlaceholder: 'Please enter sort order',
        postPaidPriceRequired:
          'Please enter postpaid price or uncheck postpaid option',
        monthlyPriceRequired:
          'Please enter monthly price or uncheck monthly option',
        annualPriceRequired:
          'Please enter annual price or uncheck annual option',
      },
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
    },
    create: {
      title: 'Product Management/Add Product',
      form: {
        productType: 'Product Type',
        productTypeRequired: 'Please select product type',
        productTypePlaceholder: 'Please select product type',
        region: 'Available Region',
        regionRequired: 'Please select available region',
        regionPlaceholder: 'Please select available region',
        clusterResource: 'Cluster Resource',
        clusterResourceRequired: 'Please select cluster resource',
        clusterResourcePlaceholder: 'Please select cluster resource',
        productSpec: 'Product Name',
        productSpecRequired: 'Please select product name',
        productSpecPlaceholder: 'Please select product name',
        priceSettings: 'Original Price',
        postPaid: 'Postpaid',
        postPaidPrice: 'Please enter price',
        postPaidUnit: '/hour',
        monthlyPaid: 'Monthly Paid',
        monthlyPrice: 'Please enter price',
        monthlyUnit: '/month',
        modelUnit: '/million tokens',
        modelInPrice: 'Reasoning for input prices',
        modelOutPrice: 'Reasoning for output prices',
        modelInPriceRequired: 'Please enter reasoning for input prices',
        modelOutPriceRequired: 'Please enter reasoning for output prices',
        input: 'input',
        output: 'output',
        annualPaid: 'Annual Paid',
        annualPrice: 'Please enter price',
        annualUnit: '/year',
        onlineSettings: 'Online Settings',
        onlineSettingsDesc:
          '“Online” refers to publishing the product to the machine learning platform. After the product is online, users can view and select the product in the machine learning platform to purchase and use when creating container instances, training tasks, or inference services. ',
        online: 'Enable',
        offline: 'Disable',
        stockStatus: 'Stock Status',
        stockStatusEnough: 'Sufficient Resources',
        stockStatusSurging: 'Tight Resources',
        stockStatusSoldOut: 'Sold Out',
        resourceTags: 'Resource Tags',
        resourceTagsGeneral: 'General',
        resourceTagsCompute: 'Compute',
        resourceTagsMemory: 'Memory',
        resourceTagsHighPerformance: 'High Performance',
        resourceTagsSpecialOffer: 'Special Offer',
        customTag: 'Custom Tag',
        customTagPlaceholder: 'Please enter tag name',
        addCustomTag: '+ Custom Tag',
        addCustomTagSuccess: 'Tag added successfully!',
        addCustomTagFailed: 'Failed to add tag, please try again',
        customTagTitle: 'Add Custom Tag',
        sortOrder: 'Sort Order',
        sortOrderPlaceholder: 'Please enter sort order',
      },
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      message: {
        createSuccess: 'Product created successfully!',
        createFailed: 'Creation failed, please try again',
      },
    },
  },
  adminRecharge: {
    title: 'User Balance',
    table: {
      nameAndId: 'User Name / ID',
      userName: 'User Name',
      balance: 'Balance',
      quota: 'Overdraft Limit',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      action: 'Action',
      recharge: 'Recharge',
      quotaConfig: 'Quota',
    },
    form: {
      user: 'User',
      balance: 'Balance',
      rechargeAmount: 'Recharge Amount',
      rechargeAmountPlaceholder: 'Recharge Amount',
      rechargeAmountRequired: 'Please enter recharge amount',
      rechargeAmountGreaterThanZero: 'Recharge amount must be greater than 0',
      contractNo: 'Contract Number',
      contractNoPlaceholder: 'Please enter contract number',
      comment: 'Comment',
      commentPlaceholder: 'Please enter comment',
      commentRequired: 'Please enter comment',
      quota: 'Overdraft Limit',
      quotaPlaceholder: 'Overdraft Limit',
      submit: 'Submit',
    },
    modal: {
      recharge: 'Recharge',
      quotaConfig: 'Overdraft Limit Configuration',
    },
  },
  cost_report: {
    alert1:
      'Cost billing provides expense allocation capabilities, distributing your resource costs to natural months according to specified allocation rules, including prepaid allocation data and postpaid billing data.',
    alert2:
      'Cost billing accounting period: The accounting period to which the allocated expense bills belong; For example, if you order annual computing resources in January, the original expense bill belongs to January accounting period, and the cost bill can be allocated to each allocation month from January to December according to the actual usage period of the resources.',
    alert3:
      'Cost expenses support filtering and classification by resource type, available region, project, billing mode, and more, supporting visual display of expense bill consumption trends and cost composition structure.',
  },
  usage_report: {
    alert1:
      'Resource usage provides a comprehensive and intuitive view to monitor and analyze the usage of computing and storage resources, as well as the workload details of tasks on the platform.',
    alert2:
      'It helps users clearly see the usage of computing and storage resources, usage trends, and identify the main sources of resource consumption, optimizing resource allocation and reducing costs.',
    alert3:
      'Based on detailed resource usage data, users can make more informed decisions about resource allocation and budget planning.',
  },
  cycle: {
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
  },
  cycleFilter: {
    billingPeriod: 'Billing Period',
    startDate: 'Start Date',
    endDate: 'End Date',
  },
  defaultClusters: {
    clusterA: 'Cluster A',
    clusterB: 'Cluster B',
    clusterC: 'Cluster C',
    clusterD: 'Cluster D',
  },
}

export default translation
